












import { Vue, Component } from 'vue-property-decorator'
import { ExStore } from 'vuex'

@Component({
  components: {
    HdView: () => import('@/components/hdTab/HdView.vue')
  }
})
export default class Hd extends Vue {
  $store!: ExStore

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get patientId() {
    return this.userInfo.id
  }
}
